import { z } from 'zod';

export const TokensSchema = z.object({
  amount: z.number(),
  playerId: z.number(),
});
